module.exports = __webpack_public_path__ + "static/media/flashpoint.e3650b2f.png";